import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'Catalogs|Achievements|Edit History|';

const sharedData: Pick<LocDef, 'htmlAllowed' | 'shared' | 'portal' | 'feature'> = {
	htmlAllowed: false,
	shared: false,
	portal: 'SP',
	feature: HubFeature.CredentialAchievements,
};

export type SPAchievementHistoryLocs =
	| 'SPAchievementHistoryNoHistory'
	| 'SPAchievementHistoryTabTitle'
	| 'SPAchievementHistoryHeading';

export const spAchievementHistoryLocs: LocDefs<SPAchievementHistoryLocs> = {
	SPAchievementHistoryNoHistory: {
		defaultValue: 'No history available.',
		description: 'Content shown when no edit history of the achievement can be found.',
		legacyName: 'Credential.Achievements/CatalogsAchievements.EditHistory.Content.NoHistory',
		displayPath: `${dpRoot}No History`,
		displayType: 'Content',
		...sharedData,
	},
	SPAchievementHistoryTabTitle: {
		defaultValue: 'Achievements Catalog Edit History',
		description: 'Tab title for the achievements edit history page.',
		legacyName: 'Credential.Achievements/CatalogsAchievements.EditHistory.Title.Pagetitle',
		displayPath: `${dpRoot}Tab Title`,
		displayType: 'Title',
		...sharedData,
	},
	SPAchievementHistoryHeading: {
		defaultValue: 'Achievements Catalog',
		description: 'Page heading for the achievements edit history page.',
		legacyName: 'Credential.Achievements/CatalogsAchievements.EditHistory.Title.Heading',
		displayPath: `${dpRoot}Heading`,
		displayType: 'Title',
		...sharedData,
	},
};

export type SPAchievementHistoryLocKeys = LocMap<SPAchievementHistoryLocs>;

export const spAchievementHistoryLocKeys: SPAchievementHistoryLocKeys =
	MapLocKeys<SPAchievementHistoryLocs>(spAchievementHistoryLocs);
